import { Typography } from "@/components";
import { cn } from "@/libraries/cn";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useNavigate, useSearch } from "@tanstack/react-router";
import type React from "react";
import { useCallback } from "react";

const tglBtnItems = [
	{
		value: "my_outstanding",
		label: "My Outstanding",
	},
	{
		value: "awaiting_response",
		label: "Awaiting Response",
	},
] as const;

const FilterAlerts = () => {
	const search = useSearch({
		strict: false,
		select: (search) => ({
			q: search.q ?? "",
			tab: search.tab ?? "my_outstanding",
		}),
	});
	const navigate = useNavigate({
		from: "/dashboard/inbox/alerts",
	});
	const onChangeTab = useCallback(
		(
			e: React.MouseEvent<HTMLElement>,
			value: "my_outstanding" | "awaiting_response",
		) => {
			e?.preventDefault();
			if (value === search.tab) return;
			return navigate({
				search: {
					q: undefined,
					tab: value,
				},
				replace: true,
			});
		},
		[navigate, search],
	);
	return (
		<div className="relative container flex gap-1 justify-between py-3">
			<ToggleButtonGroup
				value={search.tab}
				exclusive
				aria-label="My Alert Scope"
				size="small"
				className="gap-2"
				onChange={onChangeTab}
			>
				{tglBtnItems.map((item) => (
					<ToggleButton
						key={item.value}
						value={item.value}
						aria-label="left aligned"
						className={cn(
							"!rounded-full !normal-case !text-zinc-950 !bg-white !border !border-zinc-300 !py-2 !px-3",
							"[&.Mui-selected]:!border-none [&.Mui-selected]:!bg-primary [&.Mui-selected]:!text-white",
						)}
					>
						<Typography fontWeight={500} fontSize={12}>
							{item.label}
						</Typography>
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</div>
	);
};

export default FilterAlerts;
